module.exports = __webpack_public_path__ + "img/map1.fba6f9f9.jpg";